import { configureStore } from "@reduxjs/toolkit";
import selectionReducer from "./selectionSlice";
import userReducer from "./userSlice";
import mealReducer from "./mealSlice";
import mealTypesReducer from "./mealTypesSlice";
import notificationReducer from "./notificationSlice";
import saleReducer from "./saleSlice";
import globalReducer from "./globalSlice";
import userDetailReducer from "./userDetail";
export const store = configureStore({
  reducer: {
    selection: selectionReducer,
    user: userReducer,
    userDetail: userDetailReducer,
    meal: mealReducer,
    mealTypes: mealTypesReducer,
    notification: notificationReducer,
    sale: saleReducer,
    global: globalReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
